import { Component, SanEvent } from 'san';
import * as _ from 'lodash';
import {
    ICheckUsersCallback,
    IShowCheckUsersParams,
    IUser,
    IUsersParams,
    IOrganization,
} from 'src/models';

import CheckOrgUsersList from '../CheckOrgUsersList/CheckOrgUsersList';
import OrganizationTree from '../OrganizationTree/OrganizationTree';
import CheckLatelyOrganization from '../CheckLatelyOrganization/CheckLatelyOrganization';

import userService from 'src/services/user.service';
import organizationService from 'src/services/organization.service';
import { ICancelCheckUsersCallback } from 'src/models/checkUsers';

type TTab = '最近使用' | '组织架构' | '常用部门';

export default class CheckUsers extends Component {
    static components = {
        'ui-check-org-users-list': CheckOrgUsersList,
        'ui-organization-tree': OrganizationTree,
        'ui-check-lately-organization': CheckLatelyOrganization,
    };

    constructor(options: any) {
        super(options);
    }

    messages = {
        'UI:organization-tree-changed': (arg: SanEvent<any, IOrganization>) => {
            this.data.set('checkedOrganization', arg.value);
            organizationService.saveLatelyOrganization(arg.value.org_number);
            this.goToPage(1);
        },
        'UI:check-lately-organization-changed': (arg: SanEvent<any, IOrganization>) => {
            this.data.set('checkedOrganization', arg.value);
            this.goToPage(1);
        },
        'UI:check-org-users-list-page-changed': (arg: SanEvent<any, number>) => {
            this.data.set('page', arg.value);
            this.goToPage(arg.value);
        },
        'UI:check-org-users-changed': (
            arg: SanEvent<any, IUser[] /* _is_checked发生变化的用户列表 */>,
        ) => {
            this.updateCheckedUsers(arg.value);
        },
        'UI:clear-q': () => {
            this.clearCheckedOrganization();
        },
    };

    initData(): {
        isShow: boolean;
        isMultiple: boolean;
        checkedUsers: IUser[]; // 全部被选中的user
        disabledUsers: IUser[];
        callback: ICheckUsersCallback;
        cancelCallback: ICancelCheckUsersCallback;
        // 内部属性
        oneRowCheckedUsersMaxCount: number; // 选中的用户列表，一行最多显示的用户数量（超过后会展示show-more按钮）
        tabs: TTab[];
        checkedTab: TTab;
        isLately: boolean;
        checkedOrganization: IOrganization;
        q: string;
        users: IUser[];
        count: number;
        page: number;
        limit: number;
        organizationQ: string;
    } {
        return {
            checkedUsers: [],
            disabledUsers: [],
            isShow: false,
            isMultiple: false,
            callback: null,
            cancelCallback: null,
            oneRowCheckedUsersMaxCount: 10,
            tabs: ['最近使用', '组织架构', '常用部门'],
            checkedTab: '最近使用',
            isLately: true,
            checkedOrganization: null,
            q: '',
            users: [],
            count: 0,
            page: 1,
            limit: 8,
            organizationQ: '',
        };
    }

    inited() {}

    //#region owner调用
    show(params?: IShowCheckUsersParams) {
        this.data.set('isMultiple', !!params && params.isMultiple);
        this.data.set('disabledUsers', (params && params.disabledUsers) || []);
        this.data.set('callback', params && params.callback);
        this.data.set('cancelCallback', params && params.cancelCallback);
        this.data.set('isLately', true);
        this.data.set('q', '');
        this.data.set('count', 0);
        this.data.set('page', 1);
        const users = this.data.get('users');
        this.data.splice('users', [0, users.length]);
        const checkedUsers = this.data.get('checkedUsers');
        this.data.splice('checkedUsers', [0, checkedUsers.length]);
        this.data.set('isShow', true);
        this.checkTab('最近使用');
    }
    //#endregion

    checkTab(tab: TTab) {
        this.data.set('checkedTab', tab);
        this.data.set('isLately', true);
        this.data.set('q', '');
        this.data.set('checkedOrganization', null);
        const dataKey = 'users';
        const users = this.data.get(dataKey);
        this.data.splice(dataKey, [0, users.length]);
        this.goToPage(1);
    }

    search() {
        this.data.set('isLately', false);
        this.goToPage(1);
    }

    private goToPage(page: number) {
        this.data.set('page', page);
        const params = {
            page,
            q: this.data.get('q'),
            limit: this.data.get('limit'),
            is_disabled: false,
        };
        this.getUsers(params);
        this.getUsersCount(params);
    }

    private rejectDisabledUsers(users: IUser[]): IUser[] {
        const disabledUsers = this.data.get('disabledUsers');
        const disabledUserIds = _.map(disabledUsers, 'user_id');
        return _.reject(users, (user) => _.includes(disabledUserIds, user.user_id));
    }

    private getUsers(params: IUsersParams) {
        let request: Promise<any>;
        const checkedTab: TTab = this.data.get('checkedTab');
        switch (checkedTab) {
            case '最近使用':
                if (this.data.get('isLately')) {
                    request = userService.getLatelyUsers();
                } else {
                    request = userService.getUsers(params);
                }
                break;
            case '组织架构':
            case '常用部门':
                const checkedOrganization: IOrganization = this.data.get('checkedOrganization');
                if (!checkedOrganization) {
                    request = userService.getUsers(params);
                    break;
                }
                params.org_number = checkedOrganization.org_number;
                request = userService.getUsers(params);
                break;
        }
        request.then((users) => {
            const oldUsers: IUser[] = this.data.get('users');
            users = this.rejectDisabledUsers(users);
            // 更新用户列表各项的选中状态
            const checkedUsers = this.data.get('checkedUsers');
            const checkedUserIds = _.map(checkedUsers, 'user_id');
            _.forEach(users, (user) => {
                user._is_checked = _.includes(checkedUserIds, user.user_id);
            });
            this.data.splice('users', [0, oldUsers.length, ...users]);
        });
    }

    private getUsersCount(params: IUsersParams) {
        let request: Promise<any>;
        const checkedTab: TTab = this.data.get('checkedTab');
        switch (checkedTab) {
            case '最近使用':
                if (this.data.get('isLately')) {
                    return;
                } else {
                    request = userService.getUsersCount(params);
                }
                break;
            case '组织架构':
            case '常用部门':
                const checkedOrganization: IOrganization = this.data.get('checkedOrganization');
                if (!checkedOrganization) {
                    request = userService.getUsersCount(params);
                    break;
                }
                params.org_number = checkedOrganization.org_number;
                request = userService.getUsersCount(params);
                break;
        }
        request.then((count) => {
            this.data.set('count', count);
        });
    }

    private saveLatelyUsers(users: IUser[]) {
        const requests = [];
        _.forEach(users, (user) => {
            requests.push(userService.saveLatelyUser(user.user_id));
        });
        Promise.all(requests);
    }

    // 更新被选中的用户列表
    private updateCheckedUsers(checkedChangedUsers: IUser[] /* _is_checked发生变化的用户列表 */) {
        let dataKey = 'checkedUsers';
        const oldCheckedUsers: IUser[] = this.data.get(dataKey);
        const toAddUsers = _.filter(checkedChangedUsers, { _is_checked: true }); // 要选中的users
        const toRemoveUsers = _.filter(checkedChangedUsers, { _is_checked: false }); // 要取消选中的users
        // 更新选中的用户列表
        let checkedUsers: IUser[] = [];
        if (this.data.get('isMultiple')) {
            checkedUsers = _.uniqBy(_.concat(oldCheckedUsers, toAddUsers), 'user_id');
        } else {
            if (toAddUsers.length) {
                checkedUsers[0] = toAddUsers[0];
            }
        }
        checkedUsers = _.filter(checkedUsers, (user) => {
            return -1 === _.findIndex(toRemoveUsers, { user_id: user.user_id });
        });
        this.data.splice(dataKey, [0, oldCheckedUsers.length, ...checkedUsers]);
        // 更新用户列表各项的选中状态
        const checkedUserIds = _.map(checkedUsers, 'user_id');
        dataKey = 'users';
        const users = this.data.get(dataKey);
        _.forEach(users, (user) => {
            user._is_checked = _.includes(checkedUserIds, user.user_id);
        });
        this.data.splice(dataKey, [0, users.length, ...users]);
    }

    // 从已选中用户列表中，移除用户
    removeCheckedUser(user: IUser) {
        user._is_checked = false;
        this.updateCheckedUsers([user]);
    }

    searchQ(event: any) {
        if (13 === event.keyCode) {
            // 回车
            event.preventDefault(); // 阻止默认行为，防止页面跳转
            this.search();
        }
    }

    submit() {
        const checkedUsers: IUser[] = this.data.get('checkedUsers');
        this.saveLatelyUsers(checkedUsers);
        const callback = this.data.get('callback');
        if (callback) {
            callback(checkedUsers);
        }
        this.cancel();
    }

    cancel() {
        this.data.set('isShow', false);
        const cancelCallback = this.data.get('cancelCallback');
        if (cancelCallback) {
          cancelCallback();
        }
    }

    clearCheckedOrganization() {
        this.data.set('checkedOrganization', undefined);
        this.search();
        this.data.set('organizationQ', '');
    }
}
